/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingTermsDealTypeEnum } from './BookingTermsDealTypeEnum';
import {
    BookingTermsDealTypeEnumFromJSON,
    BookingTermsDealTypeEnumFromJSONTyped,
    BookingTermsDealTypeEnumToJSON,
    BookingTermsDealTypeEnumToJSONTyped,
} from './BookingTermsDealTypeEnum';
import type { SettlementBasisEnum } from './SettlementBasisEnum';
import {
    SettlementBasisEnumFromJSON,
    SettlementBasisEnumFromJSONTyped,
    SettlementBasisEnumToJSON,
    SettlementBasisEnumToJSONTyped,
} from './SettlementBasisEnum';

/**
 *
 * @export
 * @interface BookingTerms
 */
export interface BookingTerms {
    /**
     *
     * @type {BookingTermsDealTypeEnum}
     * @memberof BookingTerms
     */
    dealType: BookingTermsDealTypeEnum;
    /**
     *
     * @type {string}
     * @memberof BookingTerms
     */
    currency?: string;
    /**
     *
     * @type {string}
     * @memberof BookingTerms
     */
    rentalFee?: string;
    /**
     *
     * @type {string}
     * @memberof BookingTerms
     */
    hostPercentage?: string;
    /**
     *
     * @type {SettlementBasisEnum}
     * @memberof BookingTerms
     */
    settlementBasis?: SettlementBasisEnum;
    /**
     *
     * @type {string}
     * @memberof BookingTerms
     */
    depositAmount?: string;
    /**
     *
     * @type {Date}
     * @memberof BookingTerms
     */
    depositDueDate?: Date | null;
    /**
     *
     * @type {string}
     * @memberof BookingTerms
     */
    cancellationTerms?: string;
    /**
     *
     * @type {string}
     * @memberof BookingTerms
     */
    bookingContact?: string;
    /**
     *
     * @type {string}
     * @memberof BookingTerms
     */
    productionRequirements?: string;
}



/**
 * Check if a given object implements the BookingTerms interface.
 */
export function instanceOfBookingTerms(value: object): value is BookingTerms {
    if (!('dealType' in value) || value['dealType'] === undefined) return false;
    return true;
}

export function BookingTermsFromJSON(json: any): BookingTerms {
    return BookingTermsFromJSONTyped(json, false);
}

export function BookingTermsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingTerms {
    if (json == null) {
        return json;
    }
    return {

        'dealType': BookingTermsDealTypeEnumFromJSON(json['deal_type']),
        'currency': json['currency'] == null ? undefined : json['currency'],
        'rentalFee': json['rental_fee'] == null ? undefined : json['rental_fee'],
        'hostPercentage': json['host_percentage'] == null ? undefined : json['host_percentage'],
        'settlementBasis': json['settlement_basis'] == null ? undefined : SettlementBasisEnumFromJSON(json['settlement_basis']),
        'depositAmount': json['deposit_amount'] == null ? undefined : json['deposit_amount'],
        'depositDueDate': json['deposit_due_date'] == null ? undefined : (new Date(json['deposit_due_date'])),
        'cancellationTerms': json['cancellation_terms'] == null ? undefined : json['cancellation_terms'],
        'bookingContact': json['booking_contact'] == null ? undefined : json['booking_contact'],
        'productionRequirements': json['production_requirements'] == null ? undefined : json['production_requirements'],
    };
}

  export function BookingTermsToJSON(json: any): BookingTerms {
      return BookingTermsToJSONTyped(json, false);
  }

  export function BookingTermsToJSONTyped(value?: BookingTerms | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'deal_type': BookingTermsDealTypeEnumToJSON(value['dealType']),
        'currency': value['currency'],
        'rental_fee': value['rentalFee'],
        'host_percentage': value['hostPercentage'],
        'settlement_basis': SettlementBasisEnumToJSON(value['settlementBasis']),
        'deposit_amount': value['depositAmount'],
        'deposit_due_date': value['depositDueDate'] == null ? undefined : ((value['depositDueDate'] as any).toISOString().substring(0,10)),
        'cancellation_terms': value['cancellationTerms'],
        'booking_contact': value['bookingContact'],
        'production_requirements': value['productionRequirements'],
    };
}
